export const API_FORMAT = 'YYYY-MM-DD HH:mm';
export const SERVER_API_FORMAT = 'YYYY-MM-DD HH:mm:ss';



// WEBPACK FOOTER //
// ./src/constants/dates.js